import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getProductImage } from "../../data/images";
import { COLLECTION_COPY } from "../../data/products";
import { Reveal } from "../Reveal";
import { SectionHeading } from "../SectionHeading";

const EDIT = ["everyday", "minimal", "statement", "festive"];

// The Bracelet Edit — four signature collections with real catalogue imagery.
export const BraceletEdit = ({ editProducts = {} }) => (
  <section id="collections" className="scroll-mt-24 bg-brand-cream py-20 sm:py-28 lg:py-32" data-testid="bracelet-edit-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeading
            overline="Explore Our"
            title="The Bracelet Edit"
            text="Four moods, one wrist — every edit hand-finished to feel like a quiet part of you."
          />
          <Link
            to="/shop"
            data-testid="bracelet-edit-view-all"
            className="group inline-flex items-center gap-2 border-b border-brand-gold/60 pb-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-gold transition-colors hover:border-brand-gold hover:text-brand-gold-hover"
          >
            View all collections
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
      <div className="mt-12 grid grid-cols-2 gap-x-4 gap-y-8 sm:mt-16 sm:gap-6 lg:grid-cols-4 lg:gap-6">
        {EDIT.map((id, i) => {
          const entry = editProducts[id];
          const img = entry?.image ? getProductImage(entry.image, entry.name) : null;
          const copy = COLLECTION_COPY[id];
          return (
            <Reveal key={id} delay={(i % 4) * 0.1}>
              <Link
                to={`/shop?category=${id}`}
                data-testid={`collection-card-${id}`}
                aria-label={`Shop ${copy.title} bracelets`}
                className="group block border border-brand-sand bg-brand-surface p-3 transition-[transform,box-shadow,border-color] duration-500 ease-out hover:-translate-y-1.5 hover:border-brand-gold/60 hover:shadow-[0_28px_50px_-30px_rgba(28,25,23,0.35)] sm:p-4"
              >
                <div className="relative aspect-square overflow-hidden bg-white">
                  {img?.src ? (
                    <img
                      src={img.src}
                      alt={`${copy.title} bracelets — handcrafted by HESHAURA`}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                    />
                  ) : (
                    <img
                      src="/brand/product-placeholder.svg"
                      alt={`${copy.title} bracelets — HESHAURA photograph coming soon`}
                      loading="lazy"
                      className="h-full w-full object-cover"
                    />
                  )}
                  <span className="pointer-events-none absolute inset-3 border border-brand-gold/0 transition-colors duration-500 group-hover:border-brand-gold/30" />
                </div>
                <div className="px-1 pb-2 pt-5">
                  <h3 className="min-h-[2rem] font-serif text-xl font-medium text-brand-charcoal transition-colors duration-300 group-hover:text-brand-gold sm:min-h-[2.25rem] sm:text-2xl">
                    {copy.title} Bracelets
                  </h3>
                  <p className="mt-1.5 font-serif text-sm italic text-brand-stone">{copy.tagline}</p>
                  <p className="mt-2.5 inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold">
                    Shop now
                    <ArrowRight className="h-3 w-3 -translate-x-1 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100" />
                  </p>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
